// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_RzT","cls2":"common-cls2_-Nv common-cls1_RzT"};